<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="back()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      <ng-container *ngIf="result === 'restore'">{{ 'IAP.lbl.restore_purchase' | translate }}</ng-container>
      <ng-container *ngIf="result === 'redeem'">
        <ng-container *ngIf="upgradeMode">{{ 'PRODUCT.title.upgrade' | translate }}</ng-container>
        <ng-container *ngIf="trialMode">{{ 'PRODUCT.title.upgrade_trial' | translate }}</ng-container>
        <ng-container *ngIf="!upgradeMode && !trialMode">{{ 'PAYMENT.title.redeem' | translate }}</ng-container>
      </ng-container>
      <ng-container *ngIf="result === 'success'">{{ 'PAYMENT.title.success' | translate }}</ng-container>
      <ng-container *ngIf="result === 'fail'">{{ 'PAYMENT.title.error' | translate }}</ng-container>
    </ion-title>
  </ion-toolbar>

  <ion-toolbar class="ion-padding">
    <div class="content-div">
      <ion-img class="center thankyou-img" src="./assets/wedding/img/general/thankyou.svg" *ngIf="result !== 'fail'"></ion-img>
      <ion-img class="center thankyou-img" src="./assets/wedding/img/import/error.svg" *ngIf="result === 'fail'"></ion-img>
      <div class="ion-text-center ion-margin-top">
        <ion-text class="font-20 font-med" *ngIf="result !== 'fail'">{{ 'LBL.thank_you' | translate }}</ion-text>
        <ion-text class="font-20 font-med" *ngIf="result === 'fail'">{{ 'PAYMENT.title.fail' | translate }}</ion-text>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ng-container *ngIf="!result">
  <ion-content></ion-content>
</ng-container>
<ng-container *ngIf="result === 'success' || result === 'redeem' || result === 'restore'">
  <ng-container *ngIf="(upgradeMode || trialMode) && accountId else notUpgradeBlock">
    <ion-content>
      <div class="content-div ion-text-center ion-margin ion-padding">
        <ion-text class="font-14">{{ 'PAYMENT.msg.upgrade' | translate }}</ion-text>
      </div>
    </ion-content>
    <ion-footer >
      <ion-toolbar>
        <div class="content-div">
          <ion-button class="ion-margin" expand="block" (click)="setupAccount()">{{ 'BTN.next' | translate }}</ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-container>
  <ng-template #notUpgradeBlock>
    <ng-container *ngIf="!upgradeMode && !trialMode && creditId">
      <app-user-redeem-credit class="full-width full-height" [creditId]="creditId" pageMode="true"></app-user-redeem-credit>
    </ng-container>
    <ng-template #unknownBlock>
      <ion-content>
        <div class="content-div ion-text-center ion-margin ion-padding">
          <ion-text class="font-14">{{ 'PAYMENT.msg.unknown' | translate }}</ion-text>
        </div>
      </ion-content>
      <ion-footer>
        <ion-toolbar>
          <div class="content-div">
            <ion-button class="ion-margin" expand="block" (click)="goMainPage()">{{ 'BTN.next' | translate }}</ion-button>
          </div>
        </ion-toolbar>
      </ion-footer>
    </ng-template>
  </ng-template>
</ng-container>
<ng-container *ngIf="result === 'fail'">
  <ion-content>
    <div class="content-div ion-text-center ion-margin ion-padding">
      <ion-text class="font-14">{{ 'PAYMENT.msg.fail' | translate }}</ion-text>
    </div>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      <div class="content-div">
        <ion-button class="ion-margin" expand="block" (click)="goProductPage()">{{ 'BTN.next' | translate }}</ion-button>
      </div>
    </ion-toolbar>
  </ion-footer>
</ng-container>
